"use client"

import { BaseModal } from "@/components/BaseModal"
import { PortfolioItem } from "@/data/portfolio"
import { useLocale } from "next-intl"

type PortfolioModalProps = {
  item: PortfolioItem
  itemIndex: number
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Portfolio Modal Component
 * 
 * Uses the standardized BaseModal with portfolio-specific settings
 */
export default function PortfolioModal({ item, /* itemIndex, */ open, onOpenChange }: PortfolioModalProps) {
  const locale = useLocale()
  
  // Using global default tag styling from BaseModal
  
  return (
    <BaseModal
      item={{
        title: item.name,
        image: item.image,
        imageDark: item.imageDark,
        website: item.website,
        subtitle: item.highlight,
        description: item.description,
        note1: item.exitInfo,
        note2: item.observation,
        tags: item.tags,
        displayTags: item.displayTags,
        references: item.references
      }}
      open={open}
      onOpenChange={onOpenChange}
      locale={locale}
    />
  )
}